import { IS_PROD } from '@/config';

const PLANS = {
  FREE: 'free',
  TRIAL: 'trial',
  PRO: 'pro',
};

const ID_PLANS = {
  BR: {
    FREE: 476,
    TRIAL: 482,
    PRO: 485,
  },
  ES: {
    FREE: 281,
    TRIAL: 287,
    PRO: 290,
  },
};

const ID_PRO_FEATURES = {
  BACKGROUND_REMOVER: 'BACKGROUND_REMOVER',
  BRAND_KIT: 'BRAND_KIT',
  LOGO_BUILDER: 'LOGO_BUILDER',
  NO_CREDITS: 'NO_CREDITS',
  SCALE_DESIGN: 'SCALE_DESIGN',
  STUDIO_PRO: 'STUDIO_PRO',
  STUDIO_PRO_OFFER: 'STUDIO_PRO_OFFER',
};

const IS_PRO_FEATURE = {
  BACKGROUND_REMOVER: true,
  BRAND_KIT: true,
  LOGO_BUILDER: false,
  SCALE_DESIGN: true,
};

const CREDITS_TO_ACTIVE_FEATURE = {
  LOGO_BUILDER: 9,
  BRAND_KIT: 2,
  BACKGROUND_REMOVER: 1,
  SCALE_DESIGN: 2,
};

const CONTENT_TABS = {
  FOR_YOU: 'for_you',
  DESIGN: 'design',
  PROJECTS: 'projects',
};

const FORMATS_TO_RENDER_BY_SLUG = [
  'pack_instagram',
  'instagram_post',
  'global_facebook_post',
  'insta_stories',
  'global_facebook_vertical',
  'global_whatsapp_post',
  'capa_tiktok',
  'catalogo_virtual',
  'global_ebook_A4_Vertical',
  'mini_sites',
  'promo_link',
  'cardapio',
  'cartao_de_visita',
  'panfletos',
  'cartaz_a2',
  'certificados_sympla',
  'certificado_evenbrite',
  'stories_facebook',
  'capa_facebook',
  'capa_youtube',
  'icone_youtube',
  'link_na_bio',
  'anuncio_google',
  'anuncio_instagram',
];

const FILTER_CATEGORIES = {
  social: 'social',
  marketing: 'marketing',
  impression: 'impression',
  links: 'links',
  ebook: 'ebook',
};

const SLUGS_ON_FILTERS = {
  [FILTER_CATEGORIES.social]: [
    'pack_instagram',
    'instagram_post',
    'global_facebook_post',
    'insta_stories',
    'stories_facebook',
    'capa_tiktok',
    'capa_facebook',
  ],
  [FILTER_CATEGORIES.marketing]: [
    'global_facebook_vertical',
    'global_whatsapp_post',
    'capa_youtube',
    'icone_youtube',
    'promo_link',
    'anuncio_google',
    'anuncio_instagram',
  ],
  [FILTER_CATEGORIES.impression]: [
    'cardapio',
    'cartao_de_visita',
    'panfletos',
    'cartaz_a2',
    'certificados_sympla',
    'certificado_evenbrite',
  ],
  [FILTER_CATEGORIES.links]: [
    'catalogo_virtual',
    'mini_sites',
    'link_na_bio',
  ],
  [FILTER_CATEGORIES.ebook]: [
    'global_ebook_A4_Vertical',
  ],
};

const BLANK_DOCUMENT_ID = IS_PROD ? 'lcHHilXWa0M6I058QdoP' : '555XSytWSZUP6eRpOSxf';

const BREAKPOINTS = {
  MOBILE: 960,
  SMALL_DESKTOP: 1388,
};

export {
  PLANS,
  ID_PLANS,
  ID_PRO_FEATURES,
  IS_PRO_FEATURE,
  CREDITS_TO_ACTIVE_FEATURE,
  FORMATS_TO_RENDER_BY_SLUG,
  CONTENT_TABS,
  FILTER_CATEGORIES,
  SLUGS_ON_FILTERS,
  BLANK_DOCUMENT_ID,
  BREAKPOINTS,
};
